(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/views/success-flash.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/views/success-flash.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tur=_svs.tur||{};
_svs.tur.start_subscription=_svs.tur.start_subscription||{};
_svs.tur.start_subscription.templates=_svs.tur.start_subscription.templates||{};
svs.tur.start_subscription.templates.success_flash = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n    Du har ändrat din prenumeration.\n    Det nya priset är "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"weeklyCost") || (depth0 != null ? lookupProperty(depth0,"weeklyCost") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"weeklyCost","hash":{},"data":data,"loc":{"start":{"line":3,"column":22},"end":{"line":3,"column":36}}}) : helper)))
    + " kr/vecka.\n\n    Du hittar dina prenumerationsspel under Mina spel.";
},"useData":true});
Handlebars.partials['components-tur-start_subscription-success_flash'] = svs.tur.start_subscription.templates.success_flash;
})(svs, Handlebars);


 })(window);